<template>
  <div class="d-flex flex-md-column">
    <div class="d-flex justify-center">
      <span class="d-inline-flex position-relative">
        <SvgWrapper use="icon_svg_cart" alt="Cart" :dimensions="30" />
        <Badge
          v-if="cart.itemCount"
          :text="cart.itemCount"
          :class="'badge-winered'"
        />
      </span>
    </div>
    <span
      class="d-none d-sm-block font-size-l font-size-md-s mt-1 pb-1 ml-3 ml-md-0"
      >{{ currency(cartValue) }}</span
    >
  </div>
</template>

<script>
import { useCartStore } from '@/stores/cart'
import { mapState } from 'pinia'
import { defineAsyncComponent } from 'vue'

const Badge = defineAsyncComponent(
  () => import('@/components/basic/atoms/Badge.vue')
)
const SvgWrapper = defineAsyncComponent(
  () => import('@/components/basic/atoms/SvgWrapper.vue')
)

export default {
  components: { Badge, SvgWrapper },
  computed: {
    ...mapState(useCartStore, {
      cart: 'cartInstance',
      isUpdating: 'isUpdating'
    }),
    undiscountedGrandTotal() {
      return this.cart.undiscountedGrandTotal
    },
    shippingTotal() {
      return this.cart.shippingTotal
    },
    cartValue() {
      return this.undiscountedGrandTotal - this.shippingTotal
    }
  }
}
</script>
